import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { formFieldStyles } from "component/shared/form-fields/styles";

export const styles = (theme: Theme) => {
	return ({
		...formFieldStyles(theme),
		root: {
			position: "relative",
		},
		inputRoot: {
			paddingLeft: 0,
		},
		popper: {
			zIndex: 10,
		},
		card: {
			width: 404,
		},
		presetButton: {
			minWidth: "unset",
			width: 33,
			height: 33,
			padding: 0,
		},
	} satisfies Record<string, CSSObject>);
};
